import { PATHS, REFETCH_DATA, STORES_TYPE } from 'constants.js'
// import { fetchCountries } from 'home/actions'
import { PREFIX } from 'rankings/constants'
import type { Action } from 'redux'
import { createLogic } from 'redux-logic'
import { fetchAllClusters, fetchAllStores, fetchGeneralRevenue } from 'revenue/actions'
import type { ReduxLogicState } from 'types/logic'

interface RefetchDataProcess extends ReduxLogicState {
  action: Action
}

let lastRankingType: string | null = null

const refetchData = createLogic({
  type: [`${PREFIX}/*`, REFETCH_DATA],
  latest: true,

  async process({ action: { type }, getState }: RefetchDataProcess, dispatch, done) {
    try {
      if (type === REFETCH_DATA) {
        if (getState().router.location.pathname === PATHS.RANKINGS) {
          if (lastRankingType) {
            dispatch({ type: lastRankingType })
          }
        } else {
          dispatch(fetchGeneralRevenue())
          dispatch(fetchAllStores(STORES_TYPE.STATIONARY))
          dispatch(fetchAllClusters(STORES_TYPE.STATIONARY))
          // dispatch(fetchCountries())
        }
      } else {
        const isRankingRequest = !type.endsWith('_SUCCESS') && !type.endsWith('_ERROR')

        if (isRankingRequest) {
          lastRankingType = type
        }
      }
    } catch (error) {
      // TODO: Handle error
    }

    done()
  },
})

export default [refetchData]
